import React, { lazy } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import RouteNames from "../../constants/route_names.js";
import About from "../../views/about/index.js";
import Contact from "../../views/contact/index.js";
import Features from "../../views/features/index.js";
import GetStarted from "../../views/getstarted/index.js";
import Home from "../../views/home/index.js";
import Integrations from "../../views/integrations/index.js";
import NotFound from "../../views/notFound/index.js";
import PrivacyPolicy from "../../views/policy/index.js";
import Pricing from "../../views/pricing/index.js";
import Rcustomerhub from "../../views/resources/customerhub/index.js";
import Rfaqs from "../../views/resources/faqs/index.js";
import Rstories from "../../views/resources/success-stories/index.js";
import Rstory from "../../views/resources/success-story/index.js";
import Rtool from "../../views/resources/tool/index.js";
import Rtools from "../../views/resources/tools/index.js";
import UseCases from "../../views/resources/use-cases/index.js";
import TermsConditions from "../../views/terms/index.js";
import WhyVenueBoost from "../../views/why_venueboost/index.js";
// import BlogDetail from "../views/blog-detail";
import BlogDetailUpdated from "../../views/blog-detail-updated/index.js";
import Cookie from "../../views/cookie-policy/index.js";
import ProductUpdates from "../../views/product-updates/index.js";
import ProductDetail from "../../views/product-updates/product-detail/index.js";
import Sitemap from "../../views/sitemap/index.js";
import VendorRegister from "../../views/vendor-register/index.js";
import VendorNotVerifedScreen from "../../views/vendor-register/not_verified/index.js";
import VendorRegisterPlanPayScreen from "../../views/vendor-register/planpay/index.js";
import VendorRegisterScreen from "../../views/vendor-register/register/index.js";
import VendorRegisterVerifyScreen from "../../views/vendor-register/verify-email/index.js";
// import VenueSport from "../views/venue-sport";
import UseCaseDetails from "../../views/resources/usecase-details/index.js";

import BillingInformationScreen from "../../views/cart/billing_information.js";
import ProductDetailsScreen from "../../views/product-details/index.js";
// import OrderRetailSuccessScreen from "../views/cart/order-sucess";
// import OrderRestaurantSuccessScreen from "../views/cart/order-restaurant-sucess";
import CartOrderSuccessScreen from "../../views/cart/card-order-success.js";
import AccommodationRentalProfile from "../../views/rental/index.js";
// import ComingSoon from "../views/comingSoon";
import AffiliateCampaign from "../../views/affiliateCampaign/index.js";
import Affilicates from "../../views/affiliates/index.js";
import BpracticesDetails from "../../views/best-practice-detail/index.js";
import Bpractices from "../../views/best-practice/index.js";
import FeatureTutorials from "../../views/feature-tutorials/index.js";
import GuideDetails from "../../views/guides-detail/index.js";
import Guides from "../../views/guides/index.js";
import Onboarding from "../../views/onboarding/index.js";
import PrivacyRightRequestForm from "../../views/privacy_rights_request_form/index.js";
import PrivacyRequestFormConfirm from "../../views/privacyRequestFormConfirm/index.js";
import RateExperience from "../../views/rate_experience/index.js";
import Refer from "../../views/refer/index.js";
import BookingSuccessScreen from "../../views/rental-reserve/booking-success.js";
import RentalReserve from "../../views/rental-reserve/index.js";
import SurveyCompleted from "../../views/surveyCompleted/index.js";
import WaitlistMarketingLoggedIn from "../../views/waitlist-marketing-logged-in/index.js";
import WaitlistMarketing from "../../views/waitlist-marketing/index.js";
// import BeachBarOrder from "../views/beach-bar-order";
import GetStartedDetails from "../../views/getstarted-detail/index.js";
import GettingStarted from "../../views/gettingstarted/index.js";

import Menu from "../../views/beach-bar-order/index.js";
import Success from "../../views/beach-bar-order/Success.js";
import { CheckoutStepper } from "../../views/cart/checkout/checkout-stepper.js";
import { LoginWithFacebook } from "../../views/login/facebook-login.jsx";
import BrandLayout from "../layouts/BrandLayout.js";
import MainLayout from "../layouts/MainLayout.js";
import accommodationRoutes from "./accommodation-routes.jsx";
import AffiliateRoutes from "./affiliate-routes.jsx";
import foodRoutes from "./food-routes.jsx";
import retailRoutes from "./retailRoutes.jsx";
import sportsEntertainmentRoutes from "./sports-entertainment-routes.jsx";
import { venueRoutes } from "./venue-routes.jsx";
import whoWeServeRoutes from "./who-we-serve-routes.jsx";
const Blog = lazy(() => import("../../views/blog/index.jsx"));

const AppRoutes = () => {
  return (
    <React.Fragment>
      <Routes>
        <>
          <Route path="rental" element={<BrandLayout />}>
            <Route
              exact
              path=":code"
              element={<AccommodationRentalProfile />}
            />
            <Route exact path="reserve" element={<RentalReserve />} />
          </Route>

          <Route path="/venue" element={<BrandLayout />}>
            {venueRoutes}
          </Route>

          <Route path="/" element={<MainLayout />}>
            <Route exact path={""} element={<Home />} />
            {/*<Route exact path={RouteNames.new_home} element={<NewHome />} />*/}
            <Route exact path={"coming-soon"} element={<WaitlistMarketing />} />
            <Route
              exact
              path={"terms-conditions"}
              element={<TermsConditions />}
            />
            <Route exact path={"privacy-policy"} element={<PrivacyPolicy />} />
            <Route exact path={"about"} element={<About />} />
            <Route exact path={"contact-us"} element={<Contact />} />
            <Route exact path={"get-started"} element={<GetStarted />} />
            {/* <Route exact path={"beach-bar-order"} element={<BeachBarOrder />} /> */}
            <Route path="resources" element={<Outlet />}>
              <Route exact path={""} element={<Rcustomerhub />} />
              <Route
                exact
                path={"getting-started"}
                element={<GettingStarted />}
              />
              <Route
                exact
                path={"getting-started/:slug"}
                element={<GetStartedDetails />}
              />
              <Route exact path={"best-practices"} element={<Bpractices />} />
              <Route
                exact
                path={"best-practices/:slug"}
                element={<BpracticesDetails />}
              />
              <Route exact path={"guides-and-templates"} element={<Guides />} />
              <Route
                exact
                path={"guides-and-templates/:slug"}
                element={<GuideDetails />}
              />
              <Route
                exact
                path={"feature-tutorials"}
                element={<FeatureTutorials />}
              />
              <Route exact path={"success-stories"} element={<Rstories />} />
              <Route
                exact
                path={"resources/success-stories/:slug"}
                element={<Rstory />}
              />
              <Route exact path={"use-cases"} element={<UseCases />} />
              <Route
                exact
                path={"use-cases/:slug"}
                element={<UseCaseDetails />}
              />
              <Route exact path={"tools-guides"} element={<Rtools />} />
              <Route exact path={"tools-guides/:slug"} element={<Rtool />} />
              <Route exact path={"faqs"} element={<Rfaqs />} />
            </Route>
            <Route path={"onboarding/:token"} element={<Onboarding />} />
            <Route
              path={":venue_name/rate-your-experience/:token"}
              element={<RateExperience />}
            />
            <Route
              path={"privacy-rights-request-form"}
              element={<PrivacyRightRequestForm />}
            />
            <Route path={"survey-completed"} element={<SurveyCompleted />} />
            <Route
              path={"privacy-rights-request-confirm/:token"}
              element={<PrivacyRequestFormConfirm />}
            />
            <Route
              path={"waitlist/:token"}
              element={<WaitlistMarketingLoggedIn />}
            />
            <Route
              exact
              path={"restaurants/verify-email/:token"}
              element={<VendorRegisterVerifyScreen />}
            />
            <Route exact path={"blog"} element={<Blog />} />
            <Route exact path={"blog/:id"} element={<BlogDetailUpdated />} />
            <Route exact path={"why-venueboost"} element={<WhyVenueBoost />} />
            {/* <Route exact path={RouteNames.snapfood_network} element={<SnapfoodNetwork />} /> */}
            <Route exact path={"integrations"} element={<Integrations />} />
            <Route exact path={"pricing-plans"} element={<Pricing />} />
            <Route exact path={"features"} element={<Features />} />
            <Route
              exact
              path={"product-updates"}
              element={<ProductUpdates />}
            />
            <Route
              exact
              path={"product-updates/:slug"}
              element={<ProductDetail />}
            />
            <Route exact path={"checkout"} element={<CheckoutStepper />} />
            <Route exact path={"cookie-notice"} element={<Cookie />} />{" "}
            <Route exact path={"sitemap"} element={<Sitemap />} />
            <Route exact path={"affiliates"} element={<Affilicates />} />
            <Route exact path={"referrals"} element={<Refer />} />
            <Route
              exact
              path={"affiliate-campaign"}
              element={<AffiliateCampaign />}
            />
            <Route
              exact
              path={"facebook-login"}
              element={<LoginWithFacebook />}
            />
            <Route
              path={":token/apply/complete-registration"}
              element={<VendorRegister />}
            >
              <Route index element={<VendorRegisterScreen />} />
              <Route
                exact
                path="verify-email"
                element={<VendorNotVerifedScreen />}
              />
              <Route
                exact
                path="choose-plan-and-pay"
                element={<VendorRegisterPlanPayScreen />}
              />
            </Route>
            {/*Accommodation*/}
            {accommodationRoutes}
            {/*Retail*/}
            {sportsEntertainmentRoutes}
            <Route
              exact
              path={"beach-bar-order/:app_key/umbrella/:umbrellaNo"}
              element={<Menu />}
            />
            <Route
              exact
              path={"beach-bar-order/:app_key/umbrella/:umbrellaNo/success"}
              element={<Success />}
            />
            <Route
              exact
              path={RouteNames.billing_information}
              element={<BillingInformationScreen />}
            />
            <Route
              exact
              path={"retail/:app_key/product-details/:id"}
              element={<ProductDetailsScreen />}
            />
            <Route
              exact
              path={"order-retail-success"}
              element={<CartOrderSuccessScreen />}
            />
            <Route
              exact
              path={"order-restaurant-success"}
              element={<CartOrderSuccessScreen />}
            />
            <Route
              exact
              path={"booking-success"}
              element={<BookingSuccessScreen />}
            />
            {retailRoutes}
            {foodRoutes}
            {AffiliateRoutes}
            {whoWeServeRoutes}
          </Route>
        </>
        <Route exact path={RouteNames.not_found} element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  );
};

export default AppRoutes;
